/* ============================================================================
   money-fr.js — correctif de format monetaire pour la locale FR
   ============================================================================

   LE PROBLEME (mesure en prod le 2026-09-21)
   ------------------------------------------
   Le `moneyFormat` de la boutique est fige a "${{amount}}" et Shopify ne le
   localise PAS par locale. Tout prix rendu en SSR via le filtre Liquid `| money`
   sort donc en « $25.22 » sur /fr, alors que le francais canadien s'ecrit
   « 25,22 $ » (virgule decimale, symbole APRES, espace insecable avant).

   Mesure avant correctif : 16 a 29 prix mal formates par page FR en SSR, dont
   14 survivaient au rendu JS sur l'accueil.

   POURQUOI UN CORRECTIF GLOBAL PLUTOT QU'UN 9e CONTOURNEMENT
   ----------------------------------------------------------
   Le theme contourne deja le probleme avec `new Intl.NumberFormat` a 8 endroits
   differents (testcollection, ingredients-collection, paniervide x2, pp-buybox,
   shipping-estimate, dosage-calculator...). Chaque nouvelle section reintroduit
   le bug — c'est arrive a `kits-vedette.liquid` le 2026-09-20, ou 12 des 14 prix
   fautifs de l'accueil provenaient d'une section ecrite la veille.
   Ce fichier traite la CAUSE a un seul endroit : tout ce qui reste au format
   anglais apres le rendu est normalise, quelle que soit la section qui l'a emis.

   CE QU'IL NE FAIT PAS
   --------------------
   - Il ne touche RIEN hors locale FR (garde `lang !== 'fr'` -> sortie immediate).
   - Il ne reformate jamais un noeud contenant autre chose que le prix : seuls
     les noeuds TEXTE sont reecrits, jamais `innerHTML`. Aucune surface
     d'injection, et les elements enfants (liens, <s>, spans) restent intacts.
   - Il ignore les champs de saisie et les zones editables : reformater pendant
     que l'utilisateur tape casserait la saisie.
   - Il ne touche pas au checkout (hors thème) ni aux iframes tierces.
   ========================================================================== */
(function () {
  'use strict';

  if (document.documentElement.lang !== 'fr') return;

  var nf = new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD'
  });

  /* « $1,234.56 » ou « $ 1 234.56 » -> capture le nombre.
     Le separateur de milliers anglais est la virgule, le decimal le point.

     DEUX regex volontairement distinctes. Un seul literal avec le flag /g
     partage son `lastIndex` entre les appels : `RE.test()` dans le filtre du
     TreeWalker laisse lastIndex au-dela du match, si bien que le test suivant
     repart du milieu de la chaine et renvoie false. Resultat mesure le
     2026-09-21 : un noeud sur deux etait saute (.kv__was converti,
     .kv__price non). TEST sans /g, REPLACE avec /g.

     `(?!\d)` apres les decimales : sans lui, un montant a 3+ decimales est
     TRONQUE et le reste colle apres le symbole — « $0.125 » devenait
     « 0,12 $5 », un montant illisible et faux. Aucune surface du theme ne rend
     3 decimales aujourd'hui (moneyFormat en sort toujours 2, et aucun
     toFixed(3) dans le repo), donc c'est une garde contre un futur prix/kg a
     3 decimales, pas un bug actif. */
  var TEST = /\$\s?(?:\d{1,3}(?:,\d{3})*|\d+)\.\d{2}(?!\d)/;
  var RE = /\$\s?(\d{1,3}(?:,\d{3})*|\d+)\.(\d{2})(?!\d)/g;

  function toFr(match, intPart, decPart) {
    var cents = parseInt(intPart.replace(/,/g, ''), 10) * 100 + parseInt(decPart, 10);
    return nf.format(cents / 100);
  }

  /* Un noeud texte est candidat s'il contient un prix au format anglais et
     qu'il ne vit pas dans une zone de saisie ou un script. */
  var SKIP = /^(SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|CODE|PRE)$/;

  function walk(root) {
    if (!root) return 0;
    var n = 0;
    var it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || SKIP.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        if (p.isContentEditable) return NodeFilter.FILTER_REJECT;
        return TEST.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var batch = [];
    var cur;
    while ((cur = it.nextNode())) batch.push(cur);
    batch.forEach(function (node) {
      RE.lastIndex = 0;
      var out = node.nodeValue.replace(RE, toFr);
      if (out !== node.nodeValue) {
        node.nodeValue = out;
        n++;
      }
    });
    return n;
  }

  function run() {
    walk(document.body);
  }

  /* Trois passages, pas un seul.

     MESURE du 2026-09-21 sur /fr/products/acid-citric : le bloc
     `.pp-benchmark__line` — le COMPARATIF CONCURRENTIEL, la surface la plus
     exposee a l'art. 74.01 — restait en « $25.22 CAD » alors que tous les
     autres prix de la page etaient convertis. Le noeud passait pourtant tous
     les filtres, et rejouer la conversion a la main dessus fonctionnait.
     C'etait donc un probleme de TIMING : ce contenu n'existe pas encore au
     DOMContentLoaded et son apparition ne produit pas de mutation `childList`
     observable (reecriture en place d'un noeud deja present).

     Un MutationObserver ne rattrape que ce qui est AJOUTE ; il ne voit pas une
     valeur texte reecrite sur un noeud existant. D'ou un passage a `load`
     (toutes les ressources et scripts differes ont joue) et un dernier filet
     peu apres, qui couvre les scripts qui s'executent en fin de file. */
  function runLater() {
    run();
    setTimeout(run, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (document.readyState === 'complete') {
    runLater();
  } else {
    window.addEventListener('load', runLater);
  }

  /* Le contenu injecte apres coup doit l'etre aussi : cartes de la grille
     reconstruites en JS, mini-panier rafraichi par fetch, reponses du chat
     LiquidAI, recommandations du panier... Un MutationObserver debounce couvre
     tous ces cas sans que chaque section ait a penser au format.
     On observe le sous-arbre ajoute uniquement, pas tout le document. */
  var pending = [];
  var scheduled = false;

  function flush() {
    scheduled = false;
    var nodes = pending;
    pending = [];
    nodes.forEach(function (nd) {
      if (nd.nodeType === 1) walk(nd);
      else if (nd.nodeType === 3 && nd.parentNode) walk(nd.parentNode);
    });
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) pending.push(added[j]);
    }
    if (pending.length && !scheduled) {
      scheduled = true;
      /* rAF plutot que setTimeout : on repeint avant que l'utilisateur ne
         percoive le format anglais, et on coalesce les mutations en rafale. */
      requestAnimationFrame(flush);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
